















import {Vue, Component, Prop} from 'vue-property-decorator';
import SingleFileHolder from "@/components/util/SingleFileHolder.vue";
import FileMetaDTO from "@/dto/files/FileMetaDTO";
import PayrollService from "@/services/payroll/PayrollService";
import Application from "@/state/Application";
import Notifications from "@/state/Notifications";
import {processError} from "@/utils/ComponentUtils";
import Workspaces from "@/state/Workspaces";
import PortalCheckbox from "@/components/common/PortalCheckbox.vue";
import PortalDate from "@/components/common/PortalDate.vue";
import SimpleCompanySearch from "@/components/common/SimpleCompanySearch.vue";

@Component({
	components: {SimpleCompanySearch, PortalDate, PortalCheckbox, SingleFileHolder}
})
export default class ImportPayrollModal extends Vue {

	private file: FileMetaDTO | null = null
	private withInvoices = false
	private invoiceDate: Date | string | null = null
	private notify = true

	private internalCompanyId: number | null = null

	private selectCompany(company: {id: number}): void {
		this.internalCompanyId = company.id;
	}

	@Prop({required: false, default: function() {return Workspaces.getCurrent.id}})
	private companyId!: number | null
	@Prop({required: false, default: function() { Vue.prototype.$modal.hideAll(); return; }})
	private onSuccess!: () => void

	private importPayroll() {
		if (this.internalCompanyId == null && this.companyId == null) {
			Notifications.error("Company is mandatory field!")
			return
		}
		if (this.withInvoices) {
			Application.startLoading()
			PayrollService.importInvoiceablePayrolls(
				{
					fileMetaId: this.file!.id,
					companyId: (this.internalCompanyId ?? this.companyId)!,
					invoiceDate: this.invoiceDate,
					notify: this.notify,
				}
			).then(
				() => {
					this.onSuccess()
					Notifications.success("File has been successfully processed!");
					Application.stopLoading()
				},
				err => processError(err, this)
			)
		} else {
			Application.startLoading()
			PayrollService.importPayroll(this.file!.id, this.internalCompanyId ?? this.companyId, this.notify).then(
				() => {
					this.onSuccess()
					Notifications.success("File has been successfully processed!");
					Application.stopLoading()
				},
				err => processError(err, this)
			)
		}
	}
}
